import { Injectable, Inject } from '@angular/core';
import { Region } from '../my-features/region/region.model';
import {WINDOW} from '../window.provider';
import {AppConfigService} from './app-config.service';
import { isODM } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class WindowService {

  powerMaster = isODM;

  constructor(@Inject(WINDOW) private window: Window, private appConfigService: AppConfigService) {
  }

  getLogoPath(): string {
    let domain = this.appConfigService.getConfig();
    domain = (domain) ? domain['domainForLogo'] : '';
    const hostname = this.window.location.hostname;
    const logoPath = '/logo/' + hostname.replace(domain, '');
    return logoPath;
  }

  // Get company name.
  getHostName(): string {
    let domain = this.appConfigService.getConfig();
    domain = (domain) ? domain['domainForLogo'] : '';
    const hostname = this.window.location.hostname;
    const result = hostname.replace(domain, '');
    return result;
  }

  // Get Region
  getLogoRegion(res): any {
    let result = [];
    const domain = this.appConfigService.getConfig();
    let hostname = this.window.location.hostname;
    if (res.length > 0 && this.powerMaster) {
      if (hostname.includes(domain['domainForLogo'])) {
        hostname = hostname.replace(domain['domainForLogo'], '');
        const region = res.find(i => (i.Region !== null) && ( i.Region.toLowerCase() === hostname.toLowerCase()));
        result = region;
      } else {
        const region = res.find(i => (i.Domain !== null) && (i.Domain.toLowerCase().includes(hostname.toLowerCase())));
        result = region;
      }
    }
    return result;
  }
}
